import { render, staticRenderFns } from "./approvalbenchmark.vue?vue&type=template&id=0b73883e&scoped=true"
import script from "./approvalbenchmark.vue?vue&type=script&lang=js"
export * from "./approvalbenchmark.vue?vue&type=script&lang=js"
import style0 from "./approvalbenchmark.vue?vue&type=style&index=0&id=0b73883e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73883e",
  null
  
)

export default component.exports